import { Tooltip } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { ButtonProps, Button as RaButton } from 'react-admin';

import { PermissionActionT } from '@Common/types/bo/authorization';
import { BOResourceAll } from '@Common/types/bo_external/resources';

import { useCanAccess } from '@sh4res/bo-common/hooks';

export interface ButtonPropsI extends ButtonProps {
  'data-testid'?: string;
  readonly permissions: {
    readonly resource: BOResourceAll;
    readonly action: PermissionActionT;
  };
  /**
   * Already translated text explaining why the button is disabled, shown on hover.
   */
  readonly disabledTooltip?: string;
}

export function Button({
  permissions: { resource, action },
  'data-testid': dataTestId,
  disabledTooltip,
  ...props
}: ButtonPropsI) {
  const canAccess = useCanAccess({
    resource,
    action,
  });

  const classes = useStyles();

  if (!canAccess) {
    return null;
  }

  const button = (
    <RaButton
      className={classes.button}
      variant="contained"
      size="medium"
      {...props}
      data-testid={dataTestId}
      disableElevation={true}
    />
  );

  if (props.disabled !== true || !disabledTooltip) {
    return button;
  }

  return (
    <Tooltip title={disabledTooltip}>
      {/* span keeps the tooltip working while the button is disabled */}
      <span>{button}</span>
    </Tooltip>
  );
}

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      marginLeft: 5,
    },
  }),
);
